import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { useUtilities } from "@/hooks/useUtilities"
import {
  MissionStaffingPositionBasicFragmentFragment,
  MissionStaffingApplicationFragmentFragment,
  ListMissionStaffingPositionFragmentFragment,
} from "@/gql"
import { ref, computed } from "vue"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import { useTranslation } from "@/i18n/useTranslation"
import useRouter from "@/router/useRouter"
import ApplyForRoleModal from "./ApplyForRoleModal.vue"
import ApplyButton from "./ApplyButton.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsCard',
  props: {
    staffingPosition: null,
    refetchQueries: null,
    application: null
  },
  setup(__props: any) {

const props = __props as {
  staffingPosition:
    | MissionStaffingPositionBasicFragmentFragment
    | ListMissionStaffingPositionFragmentFragment
  refetchQueries: RefetchQueryDescription
  application?: MissionStaffingApplicationFragmentFragment
}

const { routes } = useRouter()



const { timeAgo } = useUtilities()
const { t } = useTranslation("Consultant/Opportunities")

const isApplication = computed(() => {
  return !!props.application
})

const showConfirmModal = ref(false)

return { __sfc: true,routes, props, timeAgo, t, isApplication, showConfirmModal, Icon, ApplyForRoleModal, ApplyButton }
}

})